// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__21Twn","title":"ClientInsurance_title__2TmMo","itemText":"ClientInsurance_itemText__1mNbe"};